
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook for getting and setting URL query parameters
 * 
 * @returns [value, setValue, removeValue]
 */
export function useQueryParam(key: string): [string | null, (newValue: string) => void, () => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const getValue = () => searchParams.get(key);
  
  const setValue = useCallback((newValue: string) => {
    setSearchParams(params => {
      params.set(key, newValue);
      return params;
    }, { replace: true }); // Using replace to avoid browser history issues
  }, [key, setSearchParams]);
  
  const removeValue = useCallback(() => {
    setSearchParams(params => {
      params.delete(key);
      return params;
    }, { replace: true });
  }, [key, setSearchParams]);
  
  return [getValue(), setValue, removeValue];
}
